// api_endpoints.js
export const baseURL = "https://global.thewillowquantum.com/";

// Authentication endpoints
export const AuthEndpoints = {
  LOGIN_API: baseURL + "api/login",
  SEND_FORGOT_PASSWORD_OTP: baseURL + "api/send-forgot-password-email-otp",
  VERIFY_FORGOT_PASSWORD_OTP: baseURL + "api/verify-forgot-password-email-otp",
  RESET_PASSWORD: baseURL + "api/reset-password",
};

// Registration endpoints
export const RegistrationEndpoints = {
  CHECK_USERNAME: baseURL + "api/check-username",
  CHECK_EMAIL: baseURL + "api/check-email",
  CHECK_MOBILE: baseURL + "api/check-mobile",
  CHECK_USER_CODE: baseURL + "api/check-user-code",
  CHECK_PLACEMENT_POSITION: baseURL + "api/check-placement-position",
  SEND_EMAIL_OTP: baseURL + "api/send-email-otp",
  VERIFY_EMAIL_OTP: baseURL + "api/verify-email-otp",
  REGISTER: baseURL + "api/register",
};

// In api_endpoints.js, add to DashboardEndpoints:
export const DashboardEndpoints = {
  DASHBOARD_API: baseURL + "api/user/dashboard",
  REGISTER_PAYMENT: baseURL + "api/user/register-payment",
  ACTIVE_SELF_BY_WALLET: baseURL + "api/user/active-self-by-wallet",
  FUEL_UP_MAIN_VAULT: baseURL + "api/user/credit-fuel-wallet-payment-submit",
  GET_USER_PROFILE: baseURL + "api/user/profile",
  GET_ALL_PLANS: baseURL + "api/user/get-all-plan",
  GET_ALL_PLAN_AMOUNTS: baseURL + "api/user/get-all-plan-amount",
  PLAN_UPGRADE_BY_MAIN_VAULT: baseURL + "api/user/plan-upgrade-by-main-vault",
  CHANGE_PASSWORD: baseURL + "api/user/change-password",
  GET_WALLET_TRANSACTION: baseURL + "api/user/get-wallet-transaction",
  GET_REGISTER_PAYMENT_LIST: baseURL + "api/user/get-register-payment-list",
  GET_FUEL_WALLET_PAYMENT_LIST:
    baseURL + "api/user/get-fuel-wallet-payment-list",
  GET_DIRECT_BY_USERCODE: baseURL + "api/user/get-direct-by-usercode", // Add this line
  GET_PLACEMENT_BY_USERCODE: baseURL + "api/user/get-placement-by-usercode", // Add this line
  GET_DIRECT_LEVEL_INCOME_LIST:
    baseURL + "api/user/get-direct-level-income-list",
  GET_TEAM_INCOME_LIST: baseURL + "api/user/get-team-income-list",
  GET_BINARY_INCOME: baseURL + "api/user/get-binary-income",
  GET_LOWEST_INCOME_BONUS: baseURL + "api/user/get-lowest-income-bonus",
  GET_MAX_INCOME_BONUS: baseURL + "api/user/get-max-income-bonus",
  GET_MAX_DIRECT_BONUS: baseURL + "api/user/get-max-direct-bonus",
   GET_ZERO_INCOME_BONUS: baseURL + 'api/user/get-zero-income-bonus',
GET_PACKAGE_UPGRADE_LIST: baseURL + 'api/user/get-package-upgrade-list',
// In api_endpoints.js, add these to DashboardEndpoints:
GET_USER_BY_EMAIL: baseURL + "api/user/get-user-by-email",
ACTIVE_REGISTER_USER_BY_WALLET: baseURL + "api/user/active-register-user-by-wallet",
SENT_WALLET: baseURL + "api/user/sent-wallet",
GET_USER_WALLET_BALANCE: baseURL + "api/user/get-user-wallet-balance",
ADD_BOND: baseURL + "api/user/add-bondkeys",
GET_UNUSED_BOND_KEYS: baseURL + "api/user/get-unuse-bondkeys",
GET_USED_BOND_KEYS: baseURL + "api/user/get-used-bondkeys",
CHECK_PAYMENT_STATUS: baseURL + "api/user/check-payment-status",
ACTIVE_ID_BY_BOND_KEY: baseURL + "api/user/active-id-by-bondkey",
};

// Config endpoint
export const ConfigEndpoints = {
  CONFIG_API: baseURL + "webconfig",
};
